import { gql, useQuery } from "@apollo/client";
import { useState } from "react";
import TabNavigation from "../../../../components/TabNavigation";

const GET_COUNTS = gql`
  query counts($authWhere: JSON!, $repWhere: JSON!) {
    clientCount: clientsConnection {
      aggregate {
        count
      }
    }
    authorizerCount: usersConnection(where: $authWhere) {
      aggregate {
        count
      }
    }
    repCount: usersConnection(where: $repWhere) {
      aggregate {
        count
      }
    }
  }
`;

type AggregateType = {
  aggregate: {
    count: number;
  };
};

type CountsType = {
  clientCount: AggregateType;
  authorizerCount: AggregateType;
  repCount: AggregateType;
};

const DashboardNav = () => {
  const [, setBoundaryError] = useState<Error | null>(null);
  const { data } = useQuery<CountsType>(GET_COUNTS, {
    variables: {
      authWhere: { "role.type": ["authorizer", "motion_support"] },
      repWhere: { "role.type": "sales_rep" },
    },
    onError: (error) => {
      setBoundaryError(() => {
        throw error;
      });
    },
  });

  return (
    <TabNavigation
      links={[
        {
          text: "Clients",
          url: "/admin/clients",
          notifications: data?.clientCount.aggregate.count,
        },
        {
          text: "Authorizers",
          url: "/admin/authorizers",
          notifications: data?.authorizerCount.aggregate.count,
        },
        {
          text: "Motion",
          url: "/admin/motion",
          notifications: data?.repCount.aggregate.count,
        },
      ]}
    />
  );
};

export default DashboardNav;
